<template>
  <div>
    <div class="page-wrapper-table">
      <div class="page-wrapper-table-header">
        <el-select
          class="select-primary pagination-select"
          v-model="pagination.perPage"
          :placeholder="$t('COMMON.PER_PAGE')"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <organization-selector
          v-if="
            !filterOrganization &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
          @organizationChanged="
            (organizationId) => {
              selectedOrganization = organizationId;
              selectedCustomer = null;
            }
          "
        />

        <!-- <customer-selector
          v-if="
            !filterCustomer &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
          :filterOrganization="selectedOrganization"
          @customerChanged="
            (customerId) => {
              selectedCustomer = customerId;
            }
          "
        /> -->

        <el-select
          v-model="selectedStatus"
          :placeholder="$t('ELIXIOPAY.STATUS')"
          clearable
          class="filter-select"
        >
          <el-option :label="$t('ELIXIOPAY.STATUS_PENDING')" value="pending" />
          <el-option
            :label="$t('ELIXIOPAY.STATUS_AUTHORIZED')"
            value="authorized"
          />
          <el-option
            :label="$t('ELIXIOPAY.STATUS_CAPTURED')"
            value="captured"
          />
          <el-option :label="$t('ELIXIOPAY.STATUS_PAID')" value="paid" />
          <el-option :label="$t('ELIXIOPAY.STATUS_FAILED')" value="failed" />
          <el-option
            :label="$t('ELIXIOPAY.STATUS_REFUNDED')"
            value="refunded"
          />
          <el-option
            :label="$t('ELIXIOPAY.STATUS_CANCELLED')"
            value="cancelled"
          />
        </el-select>

        <!-- <el-select
          v-model="selectedPaymentMethod"
          :placeholder="$t('ELIXIOPAY.PAYMENT_METHOD')"
          clearable
          class="filter-select"
        >
          <el-option :label="$t('ELIXIOPAY.METHOD_CB')" value="CB" />
          <el-option :label="$t('ELIXIOPAY.METHOD_TFE')" value="TFE" />
        </el-select> -->

        <!-- <el-date-picker
          class="el-input__inner date-picker"
          v-model="dateRange"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('ELIXIOPAY.START_DATE')"
          :end-placeholder="$t('ELIXIOPAY.END_DATE')"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        /> -->

        <base-input
          v-model="query"
          type="search"
          prepend-icon="fas fa-search"
          :placeholder="$t('ELIXIOPAY.SEARCH')"
          clearable
        />

        <base-button
          class="btn base-button notification bg-dark btn-icon btn-fab btn-info btn-sm mb-4"
          icon
          size="sm"
          @click="resetFilters"
        >
          <span class="btn-inner--icon">
            <i class="fa fa-undo"></i>
          </span>
        </base-button>
      </div>

      <div class="page-wrapper-table-body">
        <div class="page-wrapper-table-body-inner">
          <el-table
            class="align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="transactions"
            @sort-change="sortChange"
          >
            <div class="table-loading" slot="empty" v-if="loading">
              <img src="/img/loading.gif" />
            </div>

            <el-table-column
              :label="$t('ELIXIOPAY.ID')"
              prop="id"
              sortable="custom"
              min-width="100"
            >
              <template v-slot="{ row }">
                <span>{{ row.id }}</span>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('ELIXIOPAY.TRANSACTION_ID')"
              min-width="200"
            >
              <template v-slot="{ row }">
                <span class="font-weight-bold">
                  {{ row.provider_transaction_id || "-" }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('COMMON.ORGANIZATION')" min-width="180">
              <template v-slot="{ row }">
                <span v-if="row.organization">
                  {{ row.organization.name }}
                </span>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('ELIXIOPAY.AMOUNT')"
              prop="amount"
              sortable="custom"
              min-width="150"
            >
              <template v-slot="{ row }">
                <span class="font-weight-bold text-success">
                  {{
                    formatAmount(
                      row.amount ?? row.invoice?.totals?.total,
                      row.invoice?.currency ?? null
                    )
                  }}
                </span>
              </template>
            </el-table-column>
            <!-- 
            <el-table-column
              :label="$t('ELIXIOPAY.PAYMENT_METHOD')"
              prop="payment_method"
              sortable="custom"
              min-width="140"
            >
              <template v-slot="{ row }">
                <el-tag
                  :type="getPaymentMethodType(row.payment_method)"
                  size="small"
                >
                  {{ getPaymentMethodLabel(row.payment_method) }}
                </el-tag>
              </template>
            </el-table-column> -->

            <el-table-column
              :label="$t('ELIXIOPAY.STATUS')"
              prop="status"
              sortable="custom"
              min-width="140"
            >
              <template v-slot="{ row }">
                <el-tag :type="getStatusType(row.status)" size="small">
                  {{ getStatusLabel(row.status) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('COMMON.CREATED_AT')"
              prop="created_at"
              sortable="custom"
              min-width="180"
            >
              <template v-slot="{ row }">
                {{ $formatDate(row.created_at) }}
              </template>
            </el-table-column>

            <el-table-column fixed="right" min-width="150">
              <div slot-scope="{ row }" class="table-actions">
                <el-tooltip
                  :content="$t('COMMON.VIEW')"
                  placement="top"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_VIEW_ELIXIOPAY_TRANSACTIONS
                    )
                  "
                >
                  <a
                    type="text"
                    @click="viewTransaction(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-expand-alt"></i>
                  </a>
                </el-tooltip>

                <el-tooltip
                  :content="$t('ELIXIOPAY.RESYNC')"
                  placement="top"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_UPDATE_ELIXIOPAY_TRANSACTIONS
                    )
                  "
                >
                  <a
                    type="text"
                    @click="resyncTransaction(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-sync-alt"></i>
                  </a>
                </el-tooltip>

                <el-tooltip
                  :content="$t('COMMON.DELETE')"
                  placement="top"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_DELETE_ELIXIOPAY_TRANSACTIONS
                    )
                  "
                >
                  <a
                    type="text"
                    @click="deleteTransaction(row.id)"
                    class="table-action table-action-delete"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fal fa-trash-alt"></i>
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="page-wrapper-table-footer">
        <p class="card-category">
          {{
            $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
              from: total ? from + 1 : 0,
              to: to,
              of: total,
            })
          }}
          <span v-if="selectedRows.length">
            &nbsp; &nbsp;
            {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
          </span>
        </p>
        <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  PAYMENT_METHODS,
  PROVIDERS,
  TRANSACTION_STATUSES,
  STATUS_PENDING,
} from "@/constants/elixioPayTransactions.js";
import _ from "lodash";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Table,
  TableColumn,
  Tooltip,
  Tag,
  DatePicker,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import CustomerSelector from "@/components/CustomerSelector.vue";

export default {
  name: "elixiopay-transaction-list-table",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [DatePicker.name]: DatePicker,
    OrganizationSelector,
    CustomerSelector,
  },

  mixins: [requestErrorMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterCustomer: {
      type: String,
      default: null,
      description: "Customer id",
    },
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      transactions: [],
      loading: true,
      selectedOrganization: null,
      selectedCustomer: null,
      selectedStatus: null,
      selectedPaymentMethod: null,
      dateRange: null,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterCustomer: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedCustomer: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedStatus: {
      handler: "getListDebounced",
      immediate: false,
    },
    selectedPaymentMethod: {
      handler: "getListDebounced",
      immediate: false,
    },
    dateRange: {
      handler: "getListDebounced",
      immediate: false,
    },
  },

  methods: {
    resetFilters() {
      this.selectedOrganization = null;
      this.selectedCustomer = null;
      this.selectedStatus = null;
      this.selectedPaymentMethod = null;
      this.dateRange = null;
      this.query = null;
    },

    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
          },
          include: "organization,payable",
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };

        // Filtre organisation
        if (this.filterOrganization || this.selectedOrganization) {
          params.filter.organization_id =
            this.filterOrganization || this.selectedOrganization;
        }

        // Filtre customer
        if (this.filterCustomer || this.selectedCustomer) {
          params.filter.customer_id =
            this.filterCustomer || this.selectedCustomer;
        }

        // Filtre statut
        if (this.selectedStatus) {
          params.filter.status = this.selectedStatus;
        }

        // Filtre méthode de paiement
        if (this.selectedPaymentMethod) {
          params.filter.payment_method = this.selectedPaymentMethod;
        }

        // Filtre dates
        if (this.dateRange && this.dateRange.length === 2) {
          params.filter.date_from = this.dateRange[0];
          params.filter.date_to = this.dateRange[1];
        }

        await this.$store.dispatch("elixiopayTransactions/list", params);
        this.transactions = this.$store.getters["elixiopayTransactions/list"];
        this.total = this.$store.getters["elixiopayTransactions/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async deleteTransaction(id) {
      this.$emit("onDeleteTransaction", { id });
    },

    async resyncTransaction(transaction) {
      this.$emit("onResyncTransaction", transaction);
    },

    viewTransaction(transaction) {
      this.$emit("onViewTransaction", transaction);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },

    getStatusType(status) {
      const types = {
        pending: "warning",
        authorized: "info",
        captured: "success",
        failed: "danger",
        refunded: "warning",
        cancelled: "info",
        paid: "success",
        draft: "info",
        sent: "warning",
      };
      return types[status] || "info";
    },

    getStatusLabel(status) {
      const labels = {
        pending: this.$t("ELIXIOPAY.STATUS_PENDING"),
        authorized: this.$t("ELIXIOPAY.STATUS_AUTHORIZED"),
        captured: this.$t("ELIXIOPAY.STATUS_CAPTURED"),
        failed: this.$t("ELIXIOPAY.STATUS_FAILED"),
        refunded: this.$t("ELIXIOPAY.STATUS_REFUNDED"),
        cancelled: this.$t("ELIXIOPAY.STATUS_CANCELLED"),
        draft: this.$t("ELIXIOPAY.STATUS_DRAFT"),
        sent: this.$t("ELIXIOPAY.STATUS_SENT"),
        paid: this.$t("ELIXIOPAY.STATUS_PAID"),
      };
      return labels[status] || status;
    },

    getPaymentMethodType(method) {
      const types = {
        CB: "primary",
        TFE: "success",
      };
      return types[method] || "info";
    },

    getPaymentMethodLabel(method) {
      const labels = {
        CB: this.$t("ELIXIOPAY.METHOD_CB"),
        TFE: this.$t("ELIXIOPAY.METHOD_TFE"),
      };
      return labels[method] || method;
    },

    formatAmount(amount, currency) {
      return new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: currency || "CAD",
      }).format(amount);
    },
  },
};
</script>

<style scoped>
.filter-select {
  min-width: 150px;
  margin-right: 10px;
}

.date-picker {
  min-width: 250px;
  margin-right: 10px;
}
</style>
